module.exports = __webpack_public_path__ + "static/media/right_blob_web_trans1.cc59e2ce.png";